export default {
  login: {
    method: 'post',
    url: '/client/auth/token'
  },
  logout: {
    method: 'post',
    url: '/client/auth/user/logout'
  },
  register: {
    method: 'post',
    url: '/client/auth/register',
    headers: {
      tokenInvite: ''
    }
  },
  forgotPassword: {
    method: 'post',
    url: '/client/auth/forgot-password'
  },
  resetPassword: {
    method: 'post',
    url: '/client/auth/reset-password'
  },
  resetPasswordConfirm: {
    method: 'post',
    url: '/client/auth/reset-password-confirm'
  },
  changePassword: {
    method: 'put',
    url: '/clientauth/user/change-password'
  },
  acceptInvitation: {
    method: 'post',
    url: '/clientauth/invite/accept'
  }
}
